/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Stack } from "@mui/material";
import { defaultRichTextObjectPM } from "cms/components/components/defaults";
import { useSortableComponentList } from "cms/components/hooks/use-sortable-component-list";
import { AddLineWithIcon } from "components/add-line-with-icon";
import PositionButtons from "components/position-buttons";
import RemoveIcon from "components/remove-icon";
import { SortableContent } from "components/sortable-content";
import { Fragment } from "react";
import { cloneObjectsArray } from "utils/array";
import { ComponentImageLinkContext } from "./component-image-link-context";
import { ReactComponent as PlusRegularIcon } from "assets/images/icons/common/plus-regular-brand.svg";

const defaultItem = Object.freeze({
    image: "", // guid
    description: defaultRichTextObjectPM,
    heading: "", // string
    link: "", // guid
    position: 0, // number
});

const ComponentImageLinkEditWrapper = (props) => {
    const initialList = props?.list || [];
    const onChange = props?.onChange;
    const children = props?.children;
    
    if (typeof onChange !== "function") {
        throw Error("onChange was not supplied, or is not a function");
    }

    const { list, sortableMethods, controls } = useSortableComponentList(
        initialList,
        defaultItem,
        onChange
    );

    const { addNewItem, addNewItemBelow, removeItem, updateItems } = controls;

    const updateItemByPosition = (newItem, position) => {
        const imageArray = cloneObjectsArray(list);
        imageArray[position] = structuredClone(newItem);
        onChange(imageArray);
    };

    return (
        <Fragment>
            <div className="image-link-editor-links-title-wrapper">
                <div className="image-link-editor-links-title-label">Image Links</div>
                <div className="image-link-editor-links-title-cta" onClick={addNewItem}>
                    <div className="image-link-editor-links-title-cta-icon">
                        <PlusRegularIcon />
                    </div>
                    <div className="image-link-editor-links-title-cta-label">Add</div>
                </div>
            </div>
            <div className="simplicity-image-ImageLink">
                <Stack direction="column">
                    {list &&
                        list.map((item, index) => {
                            const { guid } = item;
                            const ctx = {
                                index,
                                list,
                                onChange,
                                guid,
                                item,
                                position: index,
                                updateItemByPosition,
                                removeItem,
                            };

                            return (
                                <ComponentImageLinkContext.Provider
                                    key={`image-list-${guid}${index}`}
                                    value={ctx}
                                >
                                    <SortableContent
                                        id={guid}
                                        index={index}
                                        sortableMethods={sortableMethods}
                                    >
                                        {children}
                                        <div>
                                            <PositionButtons
                                                index={index}
                                                list={list}
                                                handleUpdate={updateItems}
                                            />
                                            <RemoveIcon
                                                className="simplicity-composer-field-editor-remove"
                                                onDeleteItem={removeItem}
                                                index={index}
                                            />
                                        </div>
                                    </SortableContent>

                                    <AddLineWithIcon addNewItem={() => addNewItemBelow(index)} />
                                </ComponentImageLinkContext.Provider>
                            );
                        })}
                </Stack>
            </div>
        </Fragment>
    );
};
export { ComponentImageLinkEditWrapper };
